module.exports = __webpack_public_path__ + "static/media/security-camera.5054e854.svg";